import { PrescriptionSummary } from "@/domain/entity/prescription/prescription-info-entity";
import { TreatmentSummaryEntity } from "@/domain/entity/treatment/treatment-summary-entity";

export type PatientSummary = {
  doctorId?: number | null;
  doctorUuid?: string | null;
  doctorName?: string | null;
  uuid: string;
  timeZone?: string | null;
  progressStatus?: string | null;
  latestComplianceRate?: number | null;
  patientEmail?: string | null;
  patientName: string;
  patientSearchName?: string | null;
  isDeactivated: boolean;
  registrationDate?: string | null;
  isTestAccount: boolean;
  screeningId?: string | null;
  phone?: string | null;
  gender?: string | null;
  birthday?: string | null;
  isAccountSetup?: boolean | null;
  canAddTreatment?: boolean | null;
  treatments?: TreatmentSummaryEntity[];
};

export type PatientDetail = PatientSummary & {
  phone?: string | null;
  countryCode?: string | null;
  gender?: string | null;
  birthday?: string | null;
  memo?: string | null;
  prescriptions?: PrescriptionSummary[];
};

export type PatientListFilter = {
  inProgress?: boolean;
  scheduled?: boolean;
  lowCompliance?: boolean;
  activeOnly?: boolean;
  lowComplianceThreshold?: number;
};

export const LOW_COMPLIANCE_THRESHOLD = 60;
